import {Routes} from 'constants/routes';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {useNavigate} from 'react-router';
import './ManagerGreeting.scss';

const ManagerGreeting = () => {
  const navigate = useNavigate();

  return (
    <div className="manager-greeting">
      <div className="manager-greeting__content">
        <Text tag="h3" className="manager-greeting__title">
          Hi, what’s on the tap today?
        </Text>
        <div className="manager-greeting__icons">
          <div className="manager-greeting__icons-beers-tap">
            <Icon icon="beers-tap" />
          </div>
          <div>
            <Icon icon="pouring-machines" />
          </div>
        </div>
        <div className="manager-greeting__buttons">
          <Button variant="tertiary-outlined" onClick={() => navigate(Routes.BEERS_MANAGER)}>
            Update Tap
          </Button>
          <Button variant="tertiary" onClick={() => navigate(Routes.POST_GENERATOR)}>
            New Post
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ManagerGreeting;
